import './navbar.css';
import logo from '../../images/scisco-logo-black-lettering.svg';
import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';
import { Button, Menu, ThemeProvider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const NAV_ITEMS = [
  {
    label: 'Services',
    to: '/services',
    dropdown: [
      { label: 'HLA Class I & II', href: '/services#hla' },
      { label: 'KIR Haplotype', href: '/services#kir' },
      { label: 'MIC AB', href: '/services#micab' },
      { label: 'FcR & IGHG', href: '/services#fcr' },
      { label: 'Chimerism', href: '/services#chimerism' },
      { label: 'Targeted Variation', href: '/services#targeted-variation' },
    ],
  },
  {
    label: 'Kits',
    to: '/kits',
    dropdown: [
      { label: 'ScisGo™ HLA Kits', href: '/kits#hla-kit' },
      { label: 'ScisGo™ KIR Kits', href: '/kits#kir-kit' },
      { label: 'ScisGo™ Chimerism HS Kits', href: '/kits#chimerism-hs-kit' },
      { label: 'ScisGo™ Chimerism MD Kits', href: '/kits#chimerism-md-kit' },
      { label: 'ScisGo™ MHC-LOH Kits', href: '/kits#mhc-loh-kit' },
      { label: 'ScisGo™ FcR-IGHG Kits', href: '/kits#fcr-kit' },
      { label: 'Kit Workflow', href: '/kits#kit-workflow' },
      { label: 'How-to Videos', href: '/kits#videos' },
    ],
  },
  {
    label: 'ScisCloud',
    to: '/sciscloud',
    dropdown: [
      { label: 'Optional Modules', href: '/sciscloud#modules' },
      { label: 'Connected Workflow', href: '/sciscloud#workflow' },
      { label: 'HLA Typer', href: '/sciscloud#hla-typer' },
      { label: 'Engraftment Monitoring', href: '/sciscloud#chimerism' },
      { label: 'Request Access', href: '/sciscloud#request-access' },
    ],
  },
  {
    label: 'Resources & Publications',
    to: '/resources_&_publications',
    dropdown: [
      { label: 'Resources', href: '/resources_&_publications#resources' },
      { label: 'Publications', href: '/resources_&_publications#publications' },
      { label: 'Technology', href: '/technology' },
    ],
  },
  {
    label: 'Contact',
    to: '/contact',
    dropdown: [
      { label: 'Contact Info', href: '/contact#contact-info' },
      { label: 'Lab & Kit Ordering', href: '/contact#order' },
      { label: 'Contact Form', href: '/contact#contact-form' },
    ],
  },
];

const Navbar = ({ backgroundColor, theme }) => {
  const [openHamMenu, setOpenHamMenu] = useState(null);
  const open = Boolean(openHamMenu);
  const handleClick = (event) => {
    setOpenHamMenu(event.currentTarget);
  };
  const handleClose = () => {
    setOpenHamMenu(null);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  let activeStyle = {
    color: 'var(--orange)',
    fontWeight: '600',
  };

  return (
    <nav className='navbar-container' style={{ backgroundColor }}>
      <Link className='home-link' to='/' onClick={scrollToTop}>
        <img className='logo' src={logo} alt='scisco logo' />
      </Link>
      <div className='links'>
        {NAV_ITEMS.map((item) => (
          <div key={item.to} className='dropdown'>
            <NavLink
              to={item.to}
              className='link'
              onClick={scrollToTop}
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              {item.label} <span className='dropdown-arrow'>&#9660;</span>
            </NavLink>
            <div className='dropdown-menu'>
              {item.dropdown.map((sub) => (
                <a key={sub.href} href={sub.href} className='dropdown-item'>
                  {sub.label}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
      <ThemeProvider theme={theme}>
        <Button
          href='/contact#order'
          color='secondary'
          variant='contained'
          className='order-button'
          sx={{
            borderRadius: '30px',
            borderColor: 'var(--orange) !important',
            fontWeight: 700,
            border: 2,
            color: 'black',
            paddingTop: '10px',
          }}
        >
          Order
        </Button>
      </ThemeProvider>

      <div className='ham-menu'>
        <Button
          id='basic-button'
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          {open ? (
            <CloseIcon sx={{ color: 'var(--orange)', fontSize: '42px' }} />
          ) : (
            <MenuIcon sx={{ color: 'var(--orange)', fontSize: '42px' }} />
          )}
        </Button>
        <Menu
          id='basic-menu'
          anchorEl={openHamMenu}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
            className: 'ham-menu-list',
          }}
          PaperProps={{ className: 'ham-menu-paper' }}
        >
          {NAV_ITEMS.map((item) => (
            <div key={item.to} className='ham-section'>
              <NavLink
                to={item.to}
                className='link ham-parent-link'
                onClick={handleClose}
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                {item.label}
              </NavLink>
              {item.dropdown.map((sub) => (
                <a
                  key={sub.href}
                  href={sub.href}
                  className='link ham-sub-link'
                  onClick={handleClose}
                >
                  {sub.label}
                </a>
              ))}
            </div>
          ))}
          <a href='/contact/#order' className='link ham-parent-link ham-order-link' onClick={handleClose}>
            Order
          </a>
        </Menu>
      </div>
    </nav>
  );
};

export default Navbar;
